import { useEffect } from "react";
import { Formik } from "formik";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import DataSafetyMessage from "../../components/Messages/DataSafetyMessage";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addCompanyName, addMonthlyIncome } from "../../redux/slices/registerSlice";
import { enterCompanyNameValidation } from "../../validations/user.validation";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/Button/CustomButton";
import { googleEvent_LOJ061 } from "../../lib/google-analytics-loan-journey-events";
import { googleEvent_LOJ063, googleEvent_LOJ064, googleEvent_LOJ071 } from "../../lib/google-analytics";

export default function CompanyName() {
  const { companyName, monthlyIncome } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { addCompanyAndIncome, incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  useEffect(() => {
    googleEvent_LOJ061();
  }, []);

  return (
    <div className="wrapper">
      <Formik
        initialValues={{ companyName: companyName || "", monthlyIncome: monthlyIncome || "" }}
        validationSchema={enterCompanyNameValidation}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);

          setTimeout(async () => {
            const res = await addCompanyAndIncome(values);

            if (res && res.statusCode === 200) {
              dispatch(addCompanyName(values.companyName));
              dispatch(addMonthlyIncome(values.monthlyIncome));
              if (repeatCustomer) {
                navigate("/confirm-details");
              } else {
                handleStep();
              }

              googleEvent_LOJ063();
            }

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit} style={{ height: "100%" }}>
            <div className="vertical-column-layout">
              <div className="vertical-column-top">
                <MainHeader
                  title="Professional Details"
                  showProgress={true}
                  percent={46.14}
                  backPageName={repeatCustomer ? "/dashboard" : ""}
                />

                <div className="mb-2">
                  <p className="label">Enter your Company's name</p>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your Company's name"
                    name="companyName"
                    value={values.companyName}
                    onChange={(e) => {
                      setFieldValue("companyName", e.target.value);
                      googleEvent_LOJ064();
                    }}
                    onBlur={(e) => {
                      setFieldValue("companyName", e.target.value.trim());
                    }}
                    autoComplete="off"
                  />

                  {touched.companyName && errors.companyName ? (
                    <div className="error-msg">{errors.companyName}</div>
                  ) : null}
                </div>

                <br />

                <div className="mb-2">
                  <p className="label">Monthly Income</p>
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter your monthly income"
                    name="monthlyIncome"
                    value={values.monthlyIncome}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (input.length <= 10 && /^\d*$/.test(input)) {
                        setFieldValue("monthlyIncome", e.target.value);
                        googleEvent_LOJ071();
                      }
                    }}
                    onBlur={(e) => {
                      setFieldValue("monthlyIncome", e.target.value.trim());
                    }}
                    autoComplete="off"
                  />

                  {touched.monthlyIncome && errors.monthlyIncome ? (
                    <div className="error-msg">{errors.monthlyIncome}</div>
                  ) : null}
                </div>
              </div>

              <div className="vertical-column-bottom">
                <DataSafetyMessage />
                <CustomButton text="Next" type="submit" />
              </div>
            </div>

          </form>
        )}
      </Formik>
    </div>
  );
}
